import { __rest } from "tslib";
import React from "react";
import classnames from "classnames";
import isProperty from "Shared/is-property";
import { EpiProperty } from "@avensia/nitro5-scope-episerver";
import * as styles from "./input.scss";
import MyMenigoIcon from "../../MyMenigo/Shared/MyMenigoIcon/MyMenigoIcon";
function isFilledString(value) {
    if (typeof value == "number")
        return !!value;
    return !!value.trim();
}
const inputTextTypes = [
    "email",
    "password",
    "search",
    "tel",
    "text",
    "url",
];
function isInputTextType(type) {
    return typeof type === "undefined" || inputTextTypes.indexOf(type) !== -1;
}
export default class Input extends React.Component {
    constructor(props) {
        super(props);
        this.setPressedState = (pressed) => {
            this.setState({ pressed: pressed });
        };
        const value = props.value || "";
        this.state = {
            isEdited: false,
            isFilled: isFilledString(value),
            isValid: true,
            pressed: false,
            validationmessage: "",
            showRequiredValidationMessage: false,
        };
        this.initialValue = value;
    }
    UNSAFE_componentWillMount() {
        const value = this.props.value || "";
        const isFilled = isFilledString(value);
        if (isFilled !== this.state.isFilled) {
            this.setState({ isFilled });
        }
    }
    componentDidUpdate(prevProps) {
        if (this.props.value != prevProps.value && !!this.props.value)
            this.setState({
                showRequiredValidationMessage: !!!this.props.value,
            });
    }
    edited(e) {
        if (!this.state.isEdited) {
            this.setState({
                isEdited: true,
            });
        }
        const isFilled = !!e.target.value.trim();
        if (this.state.isFilled !== isFilled) {
            this.setState({
                isFilled: isFilled,
            });
        }
    }
    focus() {
        this.element.focus();
    }
    blur() {
        this.element.blur();
    }
    select() {
        this.element.select();
    }
    validate(value) {
        !!this.props.onValidate &&
            this.props
                .onValidate(value)
                .then((validationResult) => {
                this.setState({
                    isValid: validationResult.success,
                    validationmessage: validationResult.message,
                });
            });
    }
    getSize() {
        return isInputTextType(this.props.type) && !("size" in this.props)
            ? 1
            : this.props.size;
    }
    onInvalid(e) {
        !!this.element &&
            this.setState({
                showRequiredValidationMessage: !!!this.props.value,
            });
    }
    shouldShowRequiredValitationMessage() {
        return (!!this.props.requiredValidationMessage &&
            !!this.props.required &&
            !!this.state.showRequiredValidationMessage);
    }
    shouldShowValidationMessage() {
        if (this.props.showValidationMessage === false)
            return false;
        return !!this.state.validationmessage && !this.state.isValid;
    }
    render() {
        const _a = this.props, { value, defaultValue, size, children, placeholder, appearance, onValidate, requiredValidationMessage, placeholderText } = _a, restProps = __rest(_a, ["value", "defaultValue", "size", "children", "placeholder", "appearance", "onValidate", "requiredValidationMessage", "placeholderText"]);
        let inputProps = Object.assign({}, restProps, {
            className: classnames(styles.input, {
                [styles.edited]: this.state.isEdited,
                [styles.filled]: this.state.isFilled,
                [styles.customValidation]: (!!this.props.requiredValidationMessage && !!this.props.required) ||
                    !!this.validate,
                [styles.invalid]: this.shouldShowValidationMessage() ||
                    this.shouldShowRequiredValitationMessage(),
                [styles.valid]: !!this.props.value && this.state.isValid,
                [styles.disabled]: !!this.props.disabled,
                [styles.focused]: !!this.state.pressed,
            }),
            onBlur: (e) => {
                this.edited(e);
                this.setPressedState(false);
                this.props.onBlur && this.props.onBlur(e);
                if (this.props.onBlurAndChanged &&
                    this.initialValue !== this.props.value) {
                    this.props.onBlurAndChanged(this.props.value);
                }
                this.setState({
                    showRequiredValidationMessage: !!!this.element.value,
                });
                if (this.initialValue !== this.props.value) {
                    this.validate(this.props.value);
                }
            },
            onFocus: (e) => {
                this.initialValue = e.target.value;
                this.setPressedState(true);
                this.props.onFocus && this.props.onFocus(e);
            },
            onChange: (e) => {
                this.props.onChange && this.props.onChange(e);
                this.setState({
                    showRequiredValidationMessage: !!!this.element.value,
                });
            },
        });
        const appearances = typeof this.props.appearance === "string"
            ? [this.props.appearance]
            : (this.props.appearance || []);
        const elementId = !!this.props.id
            ? this.props.id
            : this.props.name ||
                "input-" + (this.props.label || "").replace(" ", "-");
        const pattern = !!restProps.type &&
            restProps.type === "number" &&
            !restProps.pattern && { pattern: "^[0-9]*$" };
        const fallbackValue = !!!value && value != "" ? undefined : "";
        const valueProp = !!!value && value != ""
            ? { defaultValue: defaultValue || fallbackValue }
            : !isNaN(+value) && value != null
                ? { value: value }
                : { value: value || fallbackValue };
        return (React.createElement(React.Fragment, null,
            !!this.props.label && (React.createElement("label", { className: classnames(styles.inputLabel), htmlFor: elementId },
                this.props.label,
                " ",
                !!this.props.required && (React.createElement("span", { className: styles.requiredLabel }, "*")))),
            React.createElement("label", { className: classnames(styles.base, this.props.className, {
                    [styles.drifting]: appearances.indexOf("drifting") !== -1,
                }) },
                React.createElement("input", Object.assign({ id: elementId, ref: (el) => (this.element = el), size: this.getSize() }, valueProp, pattern, inputProps, { placeholder: placeholderText })),
                (this.props.placeholder || this.props.children) && (React.createElement("span", { className: styles.label },
                    isProperty(placeholder) ? (React.createElement(EpiProperty, { for: placeholder, component: "span" })) : (placeholder),
                    this.props.children))),
            this.shouldShowRequiredValitationMessage() && (React.createElement("span", { className: styles.requiredField },
                React.createElement(MyMenigoIcon, { name: "alert" }),
                this.props.requiredValidationMessage)),
            this.shouldShowValidationMessage() && (React.createElement("span", { className: styles.requiredField },
                React.createElement(MyMenigoIcon, { name: "alert" }),
                this.state.validationmessage))));
    }
}
